/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description grab campaign, referrer, and traffic out of localstorage and stuff them in a string
 */

import { localStorageSingleton } from '@zcode/nr-utils'

const createCRTstring = (base?: string) => {
  const campaign: string | undefined = localStorageSingleton.getx('_campaign')
  const referrer: string | undefined = localStorageSingleton.getx('_referrer')
  const traffic: string | undefined = localStorageSingleton.getx('_traffic')
  const parts: string[] = [base || '', campaign || '', referrer || '', traffic || '']
  return parts.join(',')
}

// eslint-disable-next-line import/no-default-export
export default createCRTstring
